/**
 * Dark Mode Time Prompt - YUL ON TAP
 * 
 * Non-blocking prompt shown to users logging in between 8PM-6AM
 * when they don't have a manual dark mode preference set.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { tLang } from '../lib/langHelper';
import { useTheme } from '../contexts/ThemeContext';
import { Button } from './ui/button';
import { Moon, X } from 'lucide-react';

export default function DarkModePrompt() {
  const { i18n } = useTranslation();
  const { showTimePrompt, acceptTimeBasedDarkMode, declineTimeBasedDarkMode } = useTheme();

  if (!showTimePrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm animate-in slide-in-from-bottom-5 duration-300">
      <div className="bg-card border border-border rounded-xl shadow-lg p-4">
        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Moon className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">
              {tLang(i18n.language,
                "It's currently evening.",
                'Il fait nuit actuellement.',
                'Actualmente es de noche.')}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              {tLang(i18n.language,
                "Would you like to switch to dark mode for this session? Don't worry — it will automatically revert to light mode next time you log in.",
                'Souhaitez-vous passer en mode sombre pour cette session ? Il reviendra automatiquement au mode clair lors de votre prochaine connexion.',
                '¿Le gustaría cambiar a modo oscuro para esta sesión? No se preocupe — volverá automáticamente al modo claro la próxima vez que inicie sesión.')}
            </p>
            <div className="flex items-center space-x-2 mt-3">
              <Button
                size="sm"
                onClick={acceptTimeBasedDarkMode}
                data-testid="dark-mode-prompt-accept"
                className="bg-primary hover:bg-primary/90"
              >
                {tLang(i18n.language, 'Enable', 'Activer', 'Enable')}
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={declineTimeBasedDarkMode}
                data-testid="dark-mode-prompt-decline"
              >
                {tLang(i18n.language, 'No thanks', 'Non merci', 'No thanks')}
              </Button>
            </div>
          </div>
          <button
            onClick={declineTimeBasedDarkMode}
            className="text-muted-foreground hover:text-foreground"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
